import { SwitchCase } from '@toss/react';
import { useUser } from '@/lib/auth';
import { PlanChip } from '@/shared/components/Chip/PlanChip';
import { usePremiumAccess } from '@/shared/plan';
export const UserChip = () => {
  const {
    user
  } = useUser();
  const {
    openPlanGuide
  } = usePremiumAccess();
  return <SwitchCase value={user?.planType ?? 'FREE'} caseBy={{
    FREE: <PlanChip plan="FREE" onClick={() => void openPlanGuide({
      highlightPlan: 'PRO',
      from: 'build'
    })} className="shrink-0" />,
    BASIC: <PlanChip plan="BASIC" onClick={() => void openPlanGuide({
      highlightPlan: 'PRO',
      from: 'build'
    })} className="shrink-0" />,
    PRO: <PlanChip plan="PRO" className="shrink-0" />
  }} data-sentry-element="SwitchCase" data-sentry-component="UserChip" data-sentry-source-file="UserChip.tsx" />;
};